const Logan = Mach.requireModule('Logan');
const Raptor = Mach.requireModule('SLRaptor');
const defaultTags = {
  container: 'Mach Pro',
  osName: Mach.env.osName ?? '',
  osVersion: Mach.env.osVersion ?? '',
  appVersion: Mach.env.version ?? '',
  platform: Mach.env.isAndroid ? 'Android' : 'iOS',
  bundleName: Mach.env.bundleName ?? '',
  bundleVersion: Mach.env.bundleVersion ?? '',
};
function logan(logData) {
  const data = {
    end: 'business',
    ...logData,
    page: Mach.env?.bundleName
  };

  if (Logan) {
    try {
      const logStr = JSON.stringify(data);
      if (logStr) {
        Logan.log(logStr);
      }
    } catch (error) {}
  }
}

function reportMetrics(val, customTags = {}, sampleRate = 1) {
  const tags = { ...defaultTags, ...customTags };
  Raptor?.reportMetrics(val, checkAndConvertToString(tags), sampleRate);
}

/**
* 检查Value类型是否为字符串并转换
* @param obj
* @returns
*/
function checkAndConvertToString (obj) {
  if (Array.isArray(obj) || typeof obj !== 'object') {
    return obj;
  }

  const convertObj = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'string') {
        convertObj[key] = obj[key];
      } else if (typeof obj[key] === 'number') {
        convertObj[key] = String(obj[key]);
      }
    }
  }

  return convertObj;
}

export { logan, reportMetrics };
